import {action, computed, decorate, flow, observable, runInAction} from 'mobx';
import { ActivationCode } from '../models/activation-code';
import axios from "axios";
import alertService from "./alert";
import {Alert, AlertType} from "../models/alert";
import {User} from "../models/user";
import {navigate} from "gatsby";
import * as messages from "../components/ui_messages";
import Sequence from "../models/course/sequence";
import userService from "./user";
import Step from "../components/course-browser/step";
import ChoiceStep from "../models/course/choice-step";
import VideoStep from "../models/course/video-step";
import {AppAuth} from "../models/auth";
import sequence from "../models/course/sequence";
import Section from "../models/course/section";
import AudioStep from "../models/course/audio-step";

class GoogleAnalyticsTracking {
    constructor() {
        if (!this.isBrowser()) return;
    }

    private isBrowser = () => typeof window !== "undefined"


    trackPageView = (section : Section, sequence : Sequence, step :  ChoiceStep | VideoStep | AudioStep) => {
        let page = section.key + "/" + sequence.label.replace(/[|&;$%@"<>()+, ']/g, "") + "/" + step.key;
        let title = section.key + " - " + sequence.label + "/" + step.key;
        //
        // console.log("track pageView:", page )
        // console.log("track page title:", title )
        if (process.env.ENV == "production") { //ga isn't added in development
            window.ga('set', 'page', page);
            window.ga('set', 'title', title);
            window.ga('send', 'pageview');
        }

    }


}

decorate(GoogleAnalyticsTracking, {})

const googleAnalyticsTracking = new GoogleAnalyticsTracking();
export default googleAnalyticsTracking;